import React from "react"

class LoadingIndicator extends React.Component {
  render() {
    return (
      <div className="loading">
        <div className="loading-dot"/>
        <div className="loading-dot"/>
        <div className="loading-dot"/>
        <div className="loading-dot"/>
      </div>
    )
  }
}


export default LoadingIndicator
